import React, { useState, useRef } from "react";
import LayerPanel from "./LayerPanel";

export default function LayerPanelWithHover(props) {
  const [showPanel, setShowPanel] = useState(false);
  const hideTimeout = useRef();

  const handleMouseEnter = () => {
    clearTimeout(hideTimeout.current);
    setShowPanel(true);
  };

  const handleMouseLeave = () => {
    hideTimeout.current = setTimeout(() => setShowPanel(false), 200);
  };

  // Toggle panel on click (for mobile/touch devices)
  const handleClick = (e) => {
    e.stopPropagation();
    setShowPanel(prev => !prev);
  };

  return (
    <div
      className="layer-panel-hover-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className="layer-toggle-btn"
        tabIndex="-1"
        aria-label="Visa lagerpanel"
        type="button"
        onClick={handleClick}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path d="M12 4L2 9l10 5 10-5-10-5zm0 7.75L4.21 9.16 12 5.43l7.79 3.73L12 11.75zm0 2.84l-7.79-3.73V17l7.79 3.73L20 17v-6.14l-8 3.73z" fill="#1976d2"/>
        </svg>
      </button>
      {showPanel && (
        <div className="layer-panel-popup">
          <LayerPanel {...props} />
        </div>
      )}
    </div>
  );
}